import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants/endpoint';

import { receiveKeys } from './keys';

import type { TypeApiResponse, TypeGetRequestGoodsParams, TypeGetRequestGoodsResponse } from '~/types/receive.types';

const fetchRequestGoods = async (
  ownerCode: string,
  params: TypeGetRequestGoodsParams
): Promise<TypeGetRequestGoodsResponse> => {
  const { data } = await axiosInstance.get<TypeApiResponse<TypeGetRequestGoodsResponse>>(
    `${API_ENDPOINT.RECEIVE.GET_REQUEST_GOODS}/${ownerCode}/request/goods`,
    {
      params,
    }
  );
  return data.data;
};

type TypeUseGetRequestGoodsQueryParams = {
  ownerCode: string;
  params: TypeGetRequestGoodsParams;
  enabled?: boolean;
};

/**
 * [입고관리 > 입고요청관리] 입고상품추가 모달 > 상품 조회 Query Hook
 */
export const useGetRequestGoodsQuery = ({ ownerCode, params, enabled = true }: TypeUseGetRequestGoodsQueryParams) => {
  return useQuery({
    queryKey: receiveKeys.requestGoods(ownerCode, params),
    queryFn: () => fetchRequestGoods(ownerCode, params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
    placeholderData: keepPreviousData,
  });
};
